export default `/* Ids Hierarchy Legend Component */
.legend {
  display: flex;
  justify-content: center;
  flex-flow: wrap;
  margin-block: calc(var(--ids-space-xs) * 6);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtaGllcmFyY2h5Iiwic291cmNlcyI6WyJpZHMtaGllcmFyY2h5LWxlZ2VuZC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0FBQ0E7RUFDRTtFQUNBO0VBQ0E7RUFDQSIsInNvdXJjZXNDb250ZW50IjpbIi8qIElkcyBIaWVyYXJjaHkgTGVnZW5kIENvbXBvbmVudCAqL1xuLmxlZ2VuZCB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBmbGV4LWZsb3c6IHdyYXA7XG4gIG1hcmdpbi1ibG9jazogY2FsYyh2YXIoLS1pZHMtc3BhY2UteHMpICogNik7XG59XG4iXX0= */`;
